import { rbcAirExchangeV2Api as defaultAirExchangeV2Api } from "@b2bportal/rbc-air-exchange-v2-api";
import axios from "axios";

export const flightsExchangeV2Api = defaultAirExchangeV2Api(axios);
